import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CommonService } from './common.service';
import { UserInfoService } from './userInfo.service';

@Injectable({ providedIn: 'root' })
export class StationService {

  constructor(private commonService: CommonService, public http: HttpClient,readonly userInfoService: UserInfoService
  ) {
  }
  private _refreshNeeded$ = new Subject<void>();
  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  // service to save station 
  savestation(data: FormData): Observable<any> {
    return this.commonService.postCall(environment.API_BASE_PATH + '/chargebox/save', data);

  }

  // Service to get all Stations
  getstationlist() {
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/findall');
  }

  // need to remove after testing
  getCmsStationList_bkp() {
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/cms/findall');
  }

  getCmsStationList() {
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/getIntStation');
  }

  // Service to get station details using sationid
  getstationlistbyid(id) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/chargebox/findById/${id}`);
  }

  getListofStationsSuperAdmin(index, rows, column, direction, search) {
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/web/findall', headers);
  }

  getListofStationsCpo(vendorId, index, rows, column, direction, search) {
    let headers = { headers: { vendorId: String(vendorId), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/vendor/vendorId', headers);
  }

  // Service to get station details using vendor id
  getstationlistbyvendorid(id) {
    let headers = { headers: { vendorId: String(id) } }
    return this.commonService.getCall(environment.API_BASE_PATH + `/chargebox/vendor/vendorId`, headers);
  }

  getStationDataById(id) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/chargebox/findById/${id}`);
  }

  // Service to delete station details using sationid

  deletestationtbyid(id) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/chargebox/delete/${id}`)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      )
  }

  // Service to update station details
  updatestation(data): Observable<any> {
    return this.commonService.putCall(environment.API_BASE_PATH + '/chargebox/update', data);
  }

  // Service to update station details
  updateSecurity(stationId, flag): Observable<any> {
    const headers = { 'basicAuthEnabled': flag.toString() };
    return this.commonService.putCall(environment.API_BASE_PATH + `/chargebox/security/${stationId}`, {}, { headers: headers });
  }

  chargeboxUpdate(vendorId, chargeBoxId, status): Observable<any> {
    let fullResponse = true
    return this.commonService.getCall(environment.API_BASE_PATH + `/chargebox/updateStatus/${vendorId}/${chargeBoxId}/${status}`,{},fullResponse);
  }

  getCampaignDataStations() {
    return this.commonService.getCall(environment.API_BASE_PATH + '/campaign/getCampaignDetailsByStatus');
  }

  getCampaignDatabyId(id) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaign/chargeboxes/${id}`);
  }

  updateCampaignData(data): Observable<any> {
    return this.commonService.putCall(environment.API_BASE_PATH + '/campaign/chargeboxes/update', data);
  }

  ApproveCampaignDataStationById(chargeBoxId, status): Observable<any> {
    return this.commonService.putCall(environment.API_BASE_PATH + `/campaign/chargeboxes/update/status/${chargeBoxId}?status=${status}`, {});
  }

  getAmbiguosData(lat, lng) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaign/chargeboxes/getrecords?latitude=${lat}&longitude=${lng}`);
  }

  getAllReferrals(index, rows, column, direction, search) {
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaigns/referral/findall`, headers);
  }

  getAllReferral() {
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaigns/referral/findall`);
  }

  getReferalData() {
    return this.commonService.getCall(environment.API_BASE_PATH + `/referral/findall/`);
  }

  getAllPlantData(index, rows, column, direction, search) {
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaigns/plant-a-tree/all`, headers);
  }

  getAllAdoptedTreeData(index, rows, column, direction, search) {
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/campaigns/adopt-a-tree/web/findall`, headers);
  }

  getStatusNotification(chargebox_id): Observable<any> {
    const URL = `/chargebox/${chargebox_id}/status-notification/recent`;
    return this.commonService.getCall(environment.API_BASE_PATH + URL);
  }

  getDeviceConfig(chargebox_id,index, rows, column, direction, search): Observable<any> {
    const URL = `/devices/${chargebox_id}/configurations`;
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + URL,headers);
  }

  getDeviceTransaction(chargebox_id,index, rows, column, direction, search,fromDate,toDate): Observable<any> {
    const URL = `/charging/chargebox/${chargebox_id}`;
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search),'fromDate':fromDate,'toDate':toDate } };
    return this.commonService.getCall(environment.API_BASE_PATH + URL,headers);
  }

  getBootNotificationDetails(chargebox_id): Observable<any> {
    const URL = `/chargebox/${chargebox_id}/boot-notification`;
    return this.commonService.getCall(environment.API_BASE_PATH + URL);
  }

  getTransactionData(transactionID, startDate, endDate, interval,index, rows, column, direction, search): Observable<any> {
    let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
    interval = interval == "max" ? "all" : interval;
    let URL = `/chargebox/meter-value-history/${transactionID}`;
    if (startDate && endDate && interval)
      URL = URL + `?startDate=${startDate}&endDate=${endDate}&interval=${interval}`;
    return this.commonService.getCall(environment.API_BASE_PATH + URL,headers);
  }

  getDeviceLogs(chargebox_id, startDate?, endDate?): Observable<any> {
    let URL;
    if (startDate && endDate) {
      URL = `/devices/${chargebox_id}/logs?from=${String(this.formatDate(startDate))}&to=${String(this.formatDate(endDate))}`;
    } else {
      let today = new Date();
      let twoDaysBack = new Date();
      twoDaysBack.setDate(today.getDate() - 2);
      URL = `/devices/${chargebox_id}/logs?from=${String(this.formatDate(twoDaysBack.toString()))}&to=${String(this.formatDate(today.toString()))}`;
    }

    let headers = { headers: { 'Accept-Version': 'V2' } }
    return this.http.get(environment.API_BASE_PATH + URL, headers);
  }

  formatDate(date: string): string {
    const now = new Date(date);
    now.setMinutes(now.getMinutes());
    return now.toISOString();
  }

  deletePhoto(deviceId, fileName) {
    const URL = `/chargebox/amenity/deleteImages?deviceId=${deviceId}&fileNames=${fileName}`
    return this.commonService.deleteCall(environment.API_BASE_PATH + URL);
  }

  uploadImage(formData) {
    return this.commonService.postCall(environment.API_BASE_PATH + '/chargebox/amenity/uploadImage', formData);
  }

  forceStop(tnx_id) {
    let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
    return this.commonService.postCall(environment.API_BASE_PATH + `/charging/force-stop/${tnx_id}`, tnx_id, headers);
  }
}
